import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/api';
import { queryKeys } from '@/libs/queryKeys';

/**
 * Fetch echo IDs ranked by recent message activity.
 * @returns trendingIds — ordered array of echo IDs (most active first)
 */
export const useTrendingEchoIds = (enabled: boolean) =>
  useQuery({
    queryKey: queryKeys.echoes.trending,
    queryFn: async () => {
      const items = await api.echoes.getTrendingEchoIds();
      return items.map((i) => i.echo_id);
    },
    staleTime: 60_000,
    enabled,
  });
